import DataForm from './DataForm'
import DataFormConfig from './DataForm.config'

export const config = DataFormConfig

export default DataForm